import { useMemo } from "react";

import { useGlobal } from "../../contexts/globalContext";
import { useJanusContext } from "../../contexts/janus/JanusContext";
import { ScreenList } from "../../pages/fullscreen/screen-list";
import { Video } from "../video-element";

const createMediaStream = (track) => {
  const stream = new MediaStream();
  stream.addTrack(track);
  return stream;
};

const getResolution = (label, screens) => {
  let resolution;

  screens.forEach((screen) => {
    const remove_janus = label.replace("janus", "");
    resolution = {
      width: remove_janus === "v101" ? 1024 : screen.mini_track_name ? screen.res[2] : 42,
      height: remove_janus === "v101" ? 768 : screen.mini_track_name ? screen.res[3] : 33,
    };
  });

  return resolution;
};

export const ScreenSwitchDebugPanel = () => {
  const {
    SCREEN_REF,
    SCREEN_IS_MAIN_FG,
    MEDIA_TRACKS,
    SCREEN_SWITCH_DEBUG_PANEL,
    SCREEN_STATE,
    VIDEO_MAIN_HIDDEN,
    VIDEO_TEMP_HIDDEN,
    AUDIO_SCREEN,
    SPAN_SIZE_MAIN,
    SPAN_SIZE_TEMP,
  } = useGlobal();

  const { oldScreensArray } = useJanusContext();

  const cells = useMemo(() => {
    const tracks = Object.values(MEDIA_TRACKS).map((track) => ({ track }));

    SCREEN_REF.current.tracks = tracks;

    return tracks.map(({ track }) => {
      const resolution = getResolution(track.label, oldScreensArray);
      const stream = createMediaStream(track);

      const matches = track.label.match(/janusv(\d+)/);
      const screenId = matches && matches[1];

      return (
        <div key={screenId} id={`video__v${screenId}-mini`} className="track_container">
          {resolution && (
            <span className="resolution">
              {resolution.width}x{resolution.height}
            </span>
          )}
          <Video srcObject={stream} autoPlay muted />
          {track.label && <span className="label">{track.label}</span>}
        </div>
      );
    });
  }, [MEDIA_TRACKS]);

  return (
    <div id="fn__screen-medias" className={SCREEN_SWITCH_DEBUG_PANEL ? "" : "hide"}>
      <ScreenList controlsToggle={false} />
      <div style={{ position: "relative" }}>
        <video ref={VIDEO_MAIN_HIDDEN} id="video__screen-main" autoPlay muted />
        <label style={{ backgroundColor: SCREEN_IS_MAIN_FG ? "green" : "red" }}>{SCREEN_IS_MAIN_FG ? "F" : "B"}</label>
      </div>
      <div style={{ position: "relative" }}>
        <video ref={VIDEO_TEMP_HIDDEN} id="video__screen-temp" autoPlay muted />
        <label style={{ backgroundColor: SCREEN_IS_MAIN_FG ? "red" : "green" }}>{SCREEN_IS_MAIN_FG ? "B" : "F"}</label>
      </div>
      <div id="debug__tracks">{MEDIA_TRACKS && cells}</div>

      <audio ref={AUDIO_SCREEN} id="audio__screen" />
      <span ref={SPAN_SIZE_MAIN} id="span__screen-main-video-size" />
      <span ref={SPAN_SIZE_TEMP} id="span__screen-temp-video-size" />
    </div>
  );
};
